export const paymentMethods = {
    NONE: null,
    LATER: "Later",
    CREDIT_CARD: "CreditCard",
    PAYPAL: "Paypal",
    AFTERPAY: "Afterpay",
    PAY_NOW: "PayNow",
    INSURANCE: "Insurance",
    APPLE_PAY: "ApplePay",
};
